import { createFileRoute, redirect } from "@tanstack/react-router";

import { SignInPage } from "@/features/auth/pages";
import { safeRedirect } from "@/shared/auth/redirect";
import { hasSession } from "@/shared/auth/session";

export const Route = createFileRoute("/sign-in")({
  validateSearch: (search): { redirect?: string } =>
    typeof search["redirect"] === "string" ? { redirect: search["redirect"] } : {},
  // Signed in already, or a moment ago in this or another tab: go where the
  // person was headed.
  beforeLoad: ({ search }) => {
    if (hasSession()) throw redirect({ href: safeRedirect(search.redirect) });
  },
  component: SignInPage,
});
